export const MATTER_AGREED_FLAT_FEE_MIN_AMOUNT = 1;
export const MATTER_AGREED_FLAT_FEE_MAX_AMOUNT = 100000000;
